import React, { useEffect, useState } from "react";
import TimeField from 'react-simple-timefield';

import orderIco from "../../images/orderIco.svg"
import separatorLine from "../../images/separatorLine.svg"

import geoIco from "../../images/geoIco.svg"
import deleteIco from "../../images/deleteIco.svg"
import commentIco from "../../images/commentIco.svg"

function RouteCard({ adress, handleDelete, array, setArray, setIsValid, valid }) {

    const [timeFrom, setTimeFrom] = useState('00:00')

    const onTimeFromChange = (e, time) => {
        // console.log(e.target.value)
        setTimeFrom(e.target.value)
        let updatedPoints = array.map(item => {
            if (item.pointId === adress.pointId) {
                return {
                    ...item,
                    timeFrom: e.target.value
                }
            } else {
                return item
            }
        })
        setArray(updatedPoints)
    }

    const [timeTo, setTimeTo] = useState('00:00')

    const onTimeToChange = (e, time) => {
        setTimeTo(e.target.value)
        let updatedPoints = array.map(item => {
            if (item.pointId === adress.pointId) {
                return {
                    ...item,
                    timeTo: e.target.value
                }
            } else {
                return item
            }
        })
        setArray(updatedPoints)
    }

    const [isTimeInputShowed, setIsTimeInputShowed] = useState(false)
    const [showTime, setShowTime] = useState(false)

    const handleAddTime = () => {
        setIsTimeInputShowed(true)
        setShowTime(false)
    }

    const handleRemoveTime = () => {
        setIsTimeInputShowed(false)
        setShowTime(true)
    }

    const [isAdressInputShowed, setIsAdressInputShowed] = useState(false)
    const [adressValue, setAdressValue] = useState("")

    const handleSubmitAdress = () => {

        if (adressValue !== "") {
            let updatedPoints = array.map(item => {
                if (item.pointId === adress.pointId) {
                    return {
                        ...item,
                        adress: adressValue
                    }
                } else {
                    return item
                }
            })
            setArray(updatedPoints)
            setIsAdressInputShowed(false)
        }
    }

    useEffect(() => {
        if (adress.adress === "") {
            setIsAdressInputShowed(true)
        } else {
            setIsAdressInputShowed(false)
        }
    }, [adress.adress])



    useEffect(() => {
        if (!isTimeInputShowed) {
            if (adress.timeFrom !== "") {
                setShowTime(true)
            }

        } else {
            setShowTime(false)
        }
    })

    const [pointInfo, setPointInfo] = useState({
        adress: "",
        timeFrom: "",
        timeTo: ""
    })

    return (
        <div className="route-card">
            <img src={geoIco} alt="" className="route-card__geo-icon" />

            {
                isAdressInputShowed ?
                    <>
                        <div className="route-card__adress-input-container">
                            <img src={orderIco} alt="ввод" className="route-card__adress-input-icon" />
                            <input type="text" name="adress-a" value={adressValue} required onChange={(e) => setAdressValue(e.target.value)} id="adress-a" className="order-creation__adress-input" />
                            <button className="route-card__adress-submit-button" type="button" onClick={handleSubmitAdress}>✔</button>

                        </div>
                        <button className="routre-card__button" type="button" onClick={() => handleDelete(adress.pointId)}><img src={deleteIco} alt="" className="routre-card__button-icon"/></button>
                    </>

                    :
                    <div className="route-card__info-container">
                        <div className="routre-card__info">
                            <p className="routre-card__adress">{adress.adress}</p>
                            {
                                showTime ?
                                    <>
                                        <p className="routre-card__time">{adress.timeTo === "" ? `${adress.timeFrom}` : `${adress.timeFrom} - ${adress.timeTo}`}</p>

                                        <button className="routre-card__add-time-button" type="button" onClick={handleAddTime}>Изменить время</button>
                                    </>
                                    :
                                    <></>
                            }
                            {
                                !showTime && !isTimeInputShowed ?
                                    <button className="routre-card__add-time-button" type="button" onClick={handleAddTime}>Добавить время</button>
                                    :
                                    <></>
                            }

                            {
                                isTimeInputShowed ?
                                    <>
                                        <div className="routre-card__time-input-container">
                                            <input type="time" id="from" className="routre-card__time-input" placeholder="00:00" onChange={onTimeFromChange} />
                                            <img src={separatorLine} alt="--" />
                                            <input type="time" id="to" className="routre-card__time-input" placeholder="00:00" onChange={onTimeToChange} />

                                        </div>
                                        <button className="routre-card__time-submit-button" type="button" onClick={handleRemoveTime}>✔</button>
                                    </>

                                    :
                                    <></>
                            }


                        </div>
                        <div className="route-caard__edit-button-container">
                            <button className="routre-card__button routre-card__delete-button" type="button" onClick={() => setIsAdressInputShowed(true)}><img src={commentIco} alt="" className="routre-card__button-icon" /></button>
                            <button className="routre-card__button routre-card__delete-button" type="button" onClick={() => handleDelete(adress.pointId)}><img src={deleteIco} alt="" className="routre-card__button-icon" /></button>
                        </div>
                    </div>
            }
        </div>
    )
}

export default RouteCard